import React from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import ContentHeading from "../components/ContentHeading";
import { Helmet } from "react-helmet-async";

const TermsAndCondition = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | ASK & Associates</title>
        <meta
          name="description"
          content="Terms and Conditions governing the use of ASK & Associates website and architecture, interior design, and project management consultancy services."
        />
        <link
          rel="canonical"
          href="https://askandassociates.com/terms-condition"
        />
      </Helmet>

      <section className="section bg-lotion">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card className="border-0 shadow-sm rounded-4 p-4 p-md-5">
                {/* Header */}
                <div className="mb-4">
                  <ContentHeading heading="Legal Information" />
                  <h1 className="display-6 fw-600 text-eerie-black mb-3">
                    Terms & Conditions
                  </h1>
                  <p className="text-dark-charcoal">
                    These Terms & Conditions govern the use of the ASK &
                    Associates website and our architecture, interior design,
                    and project management consultancy services. By accessing
                    this website, you agree to be bound by these terms.
                  </p>
                </div>

                {/* ACCORDION */}
                <Accordion
                  defaultActiveKey="0"
                  flush
                  className="custom-accordion"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      1. Website Usage
                    </Accordion.Header>
                    <Accordion.Body>
                      The content of this website is provided for general
                      informational purposes only. Users must not misuse the
                      website, attempt unauthorized access, or engage in
                      activities that could harm the website or its users.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      2. Intellectual Property Rights
                    </Accordion.Header>
                    <Accordion.Body>
                      All designs, drawings, images, text, branding, and other
                      materials displayed on this website are the intellectual
                      property of ASK & Associates. Unauthorized copying,
                      reproduction, or commercial use is strictly prohibited.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      3. Service Engagement & Scope
                    </Accordion.Header>
                    <Accordion.Body>
                      Architectural, interior design, and project management
                      services are provided only through formal written
                      agreements. Information on this website does not
                      constitute a binding service contract.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      4. User Responsibilities
                    </Accordion.Header>
                    <Accordion.Body>
                      Users are responsible for providing accurate and complete
                      information during inquiries or consultations. ASK &
                      Associates shall not be liable for issues arising from
                      incorrect or incomplete information.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      5. Payments & Commercial Terms
                    </Accordion.Header>
                    <Accordion.Body>
                      Fees, payment schedules, deliverables, and timelines are
                      governed by mutually agreed contracts. Failure to adhere
                      to payment terms may result in suspension or termination
                      of services.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      6. Third-Party Links
                    </Accordion.Header>
                    <Accordion.Body>
                      This website may contain links to external websites. ASK &
                      Associates does not control or endorse the content or
                      privacy practices of third-party sites and is not
                      responsible for any damages arising from their use.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      7. Limitation of Liability
                    </Accordion.Header>
                    <Accordion.Body>
                      ASK & Associates shall not be liable for any direct,
                      indirect, incidental, or consequential damages resulting
                      from the use or inability to use this website or our
                      services.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      8. Privacy & Data Protection
                    </Accordion.Header>
                    <Accordion.Body>
                      Use of this website is subject to our Privacy Policy.
                      Personal data shared with us is handled responsibly and in
                      accordance with applicable data protection laws.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      9. Modifications to Terms
                    </Accordion.Header>
                    <Accordion.Body>
                      ASK & Associates reserves the right to modify these Terms
                      & Conditions at any time. Continued use of the website
                      constitutes acceptance of the updated terms.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      10. Governing Law & Jurisdiction
                    </Accordion.Header>
                    <Accordion.Body>
                      These Terms & Conditions are governed by the laws of
                      India. Any disputes shall be subject to the jurisdiction
                      of courts located in India.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      Contact Information
                    </Accordion.Header>
                    <Accordion.Body>
                      <strong>Email:</strong> askandassociates2017@gmail.com
                      <br />
                      <strong>Phone:</strong> +91-7021222937
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TermsAndCondition;
